import edzo from '../img/edzo.jpg'
import './Trainer.css'
import HeroCard from './HeroCard.jsx'

const Trainer = () => {
    return <div>
        <HeroCard image={edzo} name={'NÉMETH ATTILA'} title={'EDZŐ'} description={'Mindenkit olyan fizikai-mentális szintre akarok felhozni, hogyha a gyermek, vagy akár felnőtt tagunk a versenyzés mellett dönt, bármikor készen álljon rá.'} isSquare={false} />
    </div>;
};

export default Trainer;